/**
 * filter-sidebar.js
 * AJAX filter + Load More with Shopify Section Rendering API
 */
(function () {
  'use strict';

  const sectionId    = document.querySelector('[data-section-id]')?.dataset.sectionId;
  const form         = document.getElementById('facet-filters-form');
  const sidebar      = document.getElementById('filter-sidebar');
  const overlay      = document.querySelector('.js-filter-overlay');
  const openBtns     = document.querySelectorAll('.js-filter-open');
  const productsGrid = document.getElementById('CollectionProductGrid');

  if (!form || !sidebar || !sectionId) return;

  /* Drawer */

  function openDrawer(moveFocus) {
    sidebar.classList.add('is-open');
    overlay && overlay.classList.add('is-active');
    document.body.classList.add('filter-drawer-open');
    openBtns.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
    if (moveFocus) {
      const first = sidebar.querySelector('button, summary, input');
      first && first.focus();
    }
  }

  function closeDrawer() {
    sidebar.classList.remove('is-open');
    overlay && overlay.classList.remove('is-active');
    document.body.classList.remove('filter-drawer-open');
    openBtns.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    openBtns[0] && openBtns[0].focus();
  }

  openBtns.forEach(btn => btn.addEventListener('click', () => openDrawer(true)));
  overlay && overlay.addEventListener('click', closeDrawer);

  sidebar.addEventListener('click', function (e) {
    if (e.target.closest('.js-filter-close')) closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (!sidebar.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }

    if (typeof trapFocus === 'function') {
      trapFocus(sidebar, e);
    }
  });

  /* Shared fetch helper */

  let activeRequest = null;

  function fetchSection(url, callback) {
    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();

    const fetchUrl = `${url.pathname}${url.search ? url.search + '&' : '?'}sections=${sectionId}`;

    fetch(fetchUrl, { signal: activeRequest.signal })
      .then(res => {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(data => {
        const html = new DOMParser().parseFromString(data[sectionId], 'text/html');
        callback(html);
        activeRequest = null;
      })
      .catch(err => {
        if (err.name === 'AbortError') return;
        window.location.assign(url.toString());
      });
  }

  /* Filter render — replaces entire grid */

  function renderFilters(searchParams) {
    const url = new URL(form.action);
    url.search = searchParams.toString();

    history.pushState({}, '', url.toString());

    if (productsGrid) productsGrid.classList.add('is-loading');

    fetchSection(url, function (html) {

      // Replace full product grid
      const newGrid = html.getElementById('CollectionProductGrid');
      if (newGrid && productsGrid) {
        productsGrid.innerHTML = newGrid.innerHTML;
      }

      // Update filter form — counts + active states
      const newForm = html.getElementById('facet-filters-form');
      if (newForm && form) {
        form.innerHTML = newForm.innerHTML;
      }

      // Update sidebar header — Clear all + active badge
      const newHead = html.querySelector('.filter-sidebar__head');
      const curHead = sidebar.querySelector('.filter-sidebar__head');
      if (newHead && curHead) {
        curHead.innerHTML = newHead.innerHTML;
      }

      if (productsGrid) productsGrid.classList.remove('is-loading');
    });
  }

  /* Load More — appends cards, replaces button */

  function loadMore(nextUrl) {
    const btn = document.querySelector('.js-load-more');
    if (btn) {
      btn.textContent = 'Loading...';
      btn.style.pointerEvents = 'none';
    }

    fetchSection(nextUrl, function (html) {

      // Append new cards into existing grid
      const currentItems = document.getElementById('ProductGridItems');
      const newItems     = html.getElementById('ProductGridItems');
      if (currentItems && newItems) {
        currentItems.insertAdjacentHTML('beforeend', newItems.innerHTML);
      }

      // Replace only the Load More button area
      const currentLoadMore = document.getElementById('CollectionLoadMore');
      const newLoadMore     = html.getElementById('CollectionLoadMore');
      if (currentLoadMore && newLoadMore) {
        currentLoadMore.innerHTML = newLoadMore.innerHTML;
      }
    });
  }

  /* Build params from form */

  function getParams() {
    const params = new URLSearchParams(new FormData(form));
    for (const [key, val] of [...params.entries()]) {
      if (!val) params.delete(key);
    }
    return params;
  }

  /* Filter listeners */

  let priceTimer;

  form.addEventListener('change', function (e) {
    if (e.target.type === 'number') return;
    renderFilters(getParams());
  });

  form.addEventListener('input', function (e) {
    if (e.target.type !== 'number') return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(() => renderFilters(getParams()), 750);
  });

  /* Sort select */

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.js-sort-by')) return;
    const params = new URLSearchParams(window.location.search);
    params.set('sort_by', e.target.value);
    renderFilters(params);
  });

  /* Load More click — event delegation so it survives DOM swaps */

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-load-more');
    if (!btn) return;
    e.preventDefault();
    loadMore(new URL(btn.href));
  });

  /* Browser back / forward */

  window.addEventListener('popstate', function () {
    renderFilters(new URLSearchParams(window.location.search));
  });

})();